import { render, staticRenderFns } from "./moveModal.vue?vue&type=template&id=61b7ba9e&"
import script from "./moveModal.vue?vue&type=script&lang=js&"
export * from "./moveModal.vue?vue&type=script&lang=js&"
import style0 from "./moveModal.vue?vue&type=style&index=0&id=61b7ba9e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports